<dx-popup #popup *ngIf="true" [showTitle]="true" title="FAQ" [height]="700" [width]="1000" [dragEnabled]="false"
    [hideOnOutsideClick]="false" (onHidden)="onHiddenPopup($event)">
    <div *dxTemplate="let data of 'content'">

        <div class="faq-popup-wait" *ngIf="!init">
            <span class="faq-popup-wait-text">Lade Daten...</span>
        </div>

        <div class="faq-popup-content" *ngIf="init">

            <div class="faq-popup-searchView">
                <dx-text-box [(value)]="searchText" [showClearButton]="true" placeholder="Suche..."
                    valueChangeEvent="keyup" (onValueChanged)="valueChanged($event)"></dx-text-box>
            </div>

            <dx-scroll-view class="faq-popup-scrollView" #scrollView [scrollByContent]="true" [scrollByThumb]="true"
                [bounceEnabled]="false" width="100%" height="100%">

                <div class="faq-popup-item" *ngFor="let data of filteredDatas; let i = index">
                    <div class="faq-popup-item-frage" (click)="onCollapseClick(data)">
                        <div class="faq-popup-item-frage-text" [innerHTML]="data.frage"></div>

                        <dx-button class="faq-popup-item-frage-btn" type="default" icon="chevronup" *ngIf="data.isOpen">
                        </dx-button>

                        <dx-button class="faq-popup-item-frage-btn" type="default" icon="chevrondown"
                            *ngIf="!data.isOpen">
                        </dx-button>
                    </div>

                    <div class="faq-popup-item-antwort" *ngIf="data.isOpen" [innerHTML]="data.antwort">
                    </div>
                </div>

            </dx-scroll-view>
        </div>
    </div>

    <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="{
            text: 'Schließen',
            onClick: onClickClose
        }">
    </dxi-popup-toolbar-item>

</dx-popup>
